import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

export default function NotificationSkeleton() {
  return (
    <Stack spacing={2} sx={{ p: 2 }}>
      {[1, 2, 3, 4, 5].map((item) => (
        <Box key={item} sx={{ display: 'flex', gap: 2, alignItems: 'center', py: 1 }}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box sx={{ flexGrow: 1 }}>
            <Skeleton variant="text" width="60%" height={20} />
            <Skeleton variant="text" width="90%" height={15} />
          </Box>
          <Skeleton variant="text" width={50} height={15} />
        </Box>
      ))}
    </Stack>
  );
}
